import React from 'react';
import { array, func } from 'prop-types';
import { connect } from 'react-redux';
import Collect from '@fiverr-private/collect';
import { HeartIcon, HeartSolidIcon } from '@fiverr-private/visuals';
import { Container } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { PAGE_NAME } from '../../../utils/events';
import { updateCollections } from '../../../actions/collections';

const GalleryCollectButton = ({ collections, updateCollections }) => {
    const { userId, isTouch } = getContext();
    const { general, isInCheetahsMobileGigPage } = useGigPageContext();
    const { gigId } = general;

    if (!isInCheetahsMobileGigPage) {
        return null;
    }

    const resource = {
        id: gigId.toString(),
        type: Collect.RESOURCE_TYPES.GIG,
    };

    const sourceInfo = {
        name: PAGE_NAME,
        userId,
        isTouch,
    };

    const collectedKeys = new Set(
        collections.flatMap((c) => c.items.map((item) => `${item.resourceType}:${item.resourceId}`))
    );

    const isCollected = collectedKeys.has(`${resource.type}:${resource.id}`);

    const heartIcon = isCollected ? (
        <HeartSolidIcon size="lg" color="red_700" />
    ) : (
        <HeartIcon size="lg" color="white" />
    );

    return (
        <Container position="absolute" top="20px" right="20px" style={{ zIndex: 5 }}>
            <Collect
                collections={collections}
                resource={resource}
                onUpdateCollections={updateCollections}
                showMenu={false}
                heartIcon={heartIcon}
                sourceInfo={sourceInfo}
                triggerData={{
                    triggerId: 'Save a Gig',
                    triggerCopy: 'Heart icon',
                    triggerPlacement: 'Save Gig to list',
                }}
            />
        </Container>
    );
};

GalleryCollectButton.propTypes = {
    collections: array,
    updateCollections: func,
};

const mapStateToProps = ({ collections }) => ({
    collections,
});

export { GalleryCollectButton };
export default connect(mapStateToProps, { updateCollections })(GalleryCollectButton);
